import { DataBean } from "../DataBean";

export class DocumentSignPanel extends DataBean {


   

    public async getDocumentSignPanelCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "java.util.List_getDocumentSignPanelCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

    public async getDocumentSingPanelRender(idDocumentSignPanel:any,state:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "java.util.List_getDocumentSingPanelRender_Number_Number", [idDocumentSignPanel,state]);
    }

    public async updateDocumentSignPanel(bean: any): Promise<any> {
        return this.getCustomService("ProcessFlow", "com.advantage.processflow.bean.DocumentSignPanel_updateDocumentSignPanel_com.advantage.processflow.bean.DocumentSignPanel", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.processflow.bean.DocumentSignPanel"
            }
        ]);
    }

}